// extracted by mini-css-extract-plugin
export default {"bannerPhoto":"BannerPhoto_bannerPhoto__ivlU9","backgroundImage":"BannerPhoto_backgroundImage__6G74j","bannerText":"BannerPhoto_bannerText__Ojqvl"};